import { DEPARTEMENTS_METRO, DEPARTEMENTS_OUTREMER } from '../PerimetreSelector/franceDepartements';

// Palette de nuances d'orange / jaune-orange (dans la marque), une par affecte (cycle au-dela).
// Ordonnee pour garder du contraste entre deux affectes voisins (jaune / orange / brule / pale).
// Partagee entre l'edition (AffectationCarte) et l'apercu read-only (AffectationApercu).
export const PALETTE = [
  '#f97316', // orange (primaire)
  '#fde047', // jaune
  '#c2410c', // orange brule
  '#fdba74', // orange pale
  '#d97706', // ambre fonce
  '#fbbf24', // ambre / jaune-orange
  '#9a3412', // brun-orange
  '#fb923c', // orange clair
  '#b45309', // ambre brun
  '#facc15', // jaune-orange
  '#ea580c', // orange fonce
  '#fcd34d', // jaune dore
];

// Nom de departement par id (issu de la geometrie ; id = table departements). "30 - Gard".
const NOM_DEPT = new Map<number, string>(
  [...DEPARTEMENTS_METRO, ...DEPARTEMENTS_OUTREMER].map((d) => [d.id, d.nom] as [number, string]),
);

export const libelleDept = (id: number): string => `${id} - ${NOM_DEPT.get(id) ?? id}`;
